var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "#C4C4C4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.728443 11.7437C0.729061 11.7431 0.729679 11.7425 0.730297 11.7418L11.7442 0.728394C12.2136 0.258728 12.8378 0 13.5017 0C14.1656 0 14.7898 0.258522 15.2594 0.728188L26.2675 11.7361C26.2712 11.7398 26.275 11.7437 26.2787 11.7474C27.2427 12.717 27.2411 14.2902 26.2739 15.2573C25.8321 15.6994 25.2485 15.9554 24.6245 15.9822C24.5992 15.9847 24.5736 15.9859 24.5479 15.9859H24.1089V24.0912C24.1089 25.695 22.804 27 21.1997 27H16.8907C16.454 27 16.0997 26.6459 16.0997 26.209V19.8545C16.0997 19.1226 15.5044 18.5273 14.7725 18.5273H12.2309C11.499 18.5273 10.9037 19.1226 10.9037 19.8545V26.209C10.9037 26.6459 10.5496 27 10.1127 27H5.80371C4.19944 27 2.89447 25.695 2.89447 24.0912V15.9859H2.48742C1.82371 15.9859 1.19955 15.7274 0.729679 15.2577C-0.238491 14.289 -0.238903 12.7131 0.728443 11.7437Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "matrix(-1 0 0 1 27 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.410c1c26.svg";
export { ForwardRef as ReactComponent };